import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PutHistoryDTO } from '@/services/history/service/history.repository.interface.ts';
import { PutHistory } from '@/infrastructure/api-functions/interface/put-history.interface';

@injectable()
export class PutHistoryDTOImpl<T> implements PutHistoryDTO<T> {
    constructor(
        @inject(PutHistory)
        private readonly _putHistoryApi: PutHistory,
    ) { }

    async fetch(data: T): Promise<void> {
        if (data.title && data.title.includes('\n')) {
            data.title = data.title.replace(/\n/g, ' ');
        }
        await this._putHistoryApi.putHistory(data);
    }
}
